import React, { useCallback, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { useStore } from '@link/admin/stores';
import adminAuth from '@link/admin/vendors/firebase';
import { AutoLogoutDialog } from '@link/share/components';
import { clearAutoLogoutStorage, useAutoLogout } from '@link/share/hooks';
import Header from '../Header';
import Sidebar from '../Sidebar';
import styles from './base.module.css';

const BaseLayout: React.FC = () => {
  const { auth } = useStore();
  const navigate = useNavigate();

  const handleAutoLogout = useCallback(() => {
    clearAutoLogoutStorage();
    adminAuth.logout();
  }, []);

  const { warningVisible, remainingSeconds, onContinue } =
    useAutoLogout(handleAutoLogout);

  useEffect(() => {
    if (!auth.loading && auth.isUnauthorizedUser) {
      auth.clearUser();
      navigate('/login', { replace: true });
    }
  }, [auth.isUnauthorizedUser, auth, navigate]);

  return (
    <div className={styles.base}>
      <Header />
      <div className={styles.container}>
        <Sidebar />
        <main className={styles.main}>
          <div className={styles.inner}>
            <Outlet />
          </div>
        </main>
      </div>
      <AutoLogoutDialog
        visible={warningVisible}
        remainingSeconds={remainingSeconds}
        onContinue={onContinue}
        onLogout={handleAutoLogout}
      />
    </div>
  );
};

export default BaseLayout;
